(() => {
  'use strict';

  const catalog = window.KP_MACHINE_CATALOG || {};
  const prefix = 'kp_machine_fit_v2_';
  try {
    Object.entries(catalog).forEach(([handle, entry]) => {
      sessionStorage.setItem(prefix + handle, JSON.stringify(entry));
    });
  } catch (e) {}

  // KaffeParts server-order guard v1.0.0
  // Collection order is owned by Shopify MANUAL sorting before pagination.
  // Finder/stock scripts may decorate, grey or hide cards, but must not move
  // existing product cards and thereby destroy the global KP item-number order.
  if (!window.__kpServerOrderGuardInstalled) {
    window.__kpServerOrderGuardInstalled = true;
    const nativeAppendChild = Node.prototype.appendChild;

    Node.prototype.appendChild = function(node) {
      try {
        if (
          node &&
          node.nodeType === 1 &&
          node.matches?.('.grid__item') &&
          node.parentElement?.id === 'product-grid' &&
          (this.id === 'product-grid' || this.nodeType === 11)
        ) {
          return node;
        }
      } catch (e) {}
      return nativeAppendChild.call(this, node);
    };
  }
})();
